import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function AdminTrials() {
  const [players, setPlayers] = useState([]);
  const [ratings, setRatings] = useState({});
  const load = async () => {
    const r = await api.get("/admin/players", { params: { status: "approved" } });
    setPlayers(r.data);
    const t = await api.get("/admin/trials");
    const m = {}; t.data.forEach((x) => m[x.player_id] = x);
    setRatings(m);
  };
  useEffect(() => { load(); }, []);
  const save = async (pid, patch) => {
    const cur = ratings[pid] || { player_id: pid, present: false, batting: 0, bowling: 0, fielding: 0, fitness: 0, overall: 0, remarks: "", selected: false };
    const next = { ...cur, ...patch };
    setRatings({ ...ratings, [pid]: next });
    try { await api.post("/admin/trials", next); } catch { toast.error("Save failed"); }
  };
  return (
    <div>
      <div className="text-xs uppercase tracking-[0.4em] text-[#39FF14]">Trials</div>
      <h1 className="font-display text-4xl mt-2">Attendance & Ratings</h1>
      <div className="mt-4 text-sm text-white/60">Only approved players are shown. Updates auto-save.</div>
      <div className="mt-6 overflow-x-auto border border-white/10 rounded">
        <table className="w-full text-sm">
          <thead className="bg-[#151F3D] text-white/70"><tr>
            {["Reg","Trial","Name","Mobile","Present","Bat","Bowl","Field","Fit","Overall","Remarks","Selected"].map((h)=>(
              <th key={h} className="px-2 py-3 text-left text-xs uppercase tracking-widest">{h}</th>))}</tr></thead>
          <tbody>
            {players.map((p) => {
              const r = ratings[p.id] || {};
              return (
                <tr key={p.id} className="border-t border-white/5" data-testid={`trial-row-${p.id}`}>
                  <td className="px-2 py-2 text-xs text-[#FFD700]">{p.registration_number}</td>
                  <td className="px-2 py-2 text-xs">{p.trial_number || "—"}</td>
                  <td className="px-2 py-2">{p.name}</td>
                  <td className="px-2 py-2 text-xs">{p.mobile}</td>
                  <td className="px-2 py-2"><input type="checkbox" checked={!!r.present} onChange={(e)=>save(p.id,{present: e.target.checked})} /></td>
                  {["batting","bowling","fielding","fitness","overall"].map((k) => (
                    <td key={k} className="px-2 py-2"><input type="number" min="0" max="10" value={r[k] ?? 0} onChange={(e)=>save(p.id,{[k]: +e.target.value})} className="w-14 bg-black/50 border border-white/15 px-2 py-1 text-center" /></td>
                  ))}
                  <td className="px-2 py-2"><input value={r.remarks || ""} onChange={(e)=>save(p.id,{remarks: e.target.value})} className="w-40 bg-black/50 border border-white/15 px-2 py-1 text-xs" /></td>
                  <td className="px-2 py-2"><label className="flex items-center gap-1"><input type="checkbox" checked={!!r.selected} onChange={(e)=>save(p.id,{selected: e.target.checked})} /><span className="text-xs text-[#39FF14]">{r.selected?"YES":""}</span></label></td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
